<template>
    <div>
        <Portlet class="right-panel" :fullHeight="true" :noPadding="true">
            <template slot="Title">
                Sources
            </template>
            <template slot="Options">
                <!---->
            </template>
            <template slot="Content">
                <div id="dayTemplate-source" class="accordion">
                    <template v-for="section in sections">
                        <ItemMenuList :key="section.key" :isLoading="isLoadingStationClocks" :noAction="true" >
                            <template slot="Content">
                                <div :class="['category']" @click="toggleSection(section.key)">
                                    <i :class="['fas', expandedSections.includes(section.key) === true ? 'fa-chevron-down' : 'fa-chevron-right' ]"></i>
                                    <a href="#" class="hlp hlp__uppercase">{{section.key === 'UNDEFINED' ? section.type : section.key}}</a>
                                </div>
                                <b-list-group v-if="section.items && expandedSections.includes(section.key)" class="day-template__source-panel--list-group">
                                    <MenuCard v-for="clock in section.items" :key="clock.uid" :isDraggable="true" :disableLink="true" :menuItem="clock" :itemType="section.type" :href="''">
                                        <template slot="Decorator">
                                            <a href="#" @click="emitEvent(section.event,clock)">
                                                <i class="fas fa-circle" :style="{ color: clock.colorCode }"></i>
                                            </a>
                                        </template>
                                        <template slot="Badge">
                                            <span></span>
                                        </template>
                                    </MenuCard>
                                </b-list-group>
                            </template>
                        </ItemMenuList>
                    </template>
                </div>
            </template>
        </Portlet>
    </div>
</template>
<script>
    import Translations from '@/store/translations';
    import router from '@/router';
    import EventBus from '@/eventbus';
    import Portlet from '@/components/common/Portlet.vue'
    import WaitingBlock from '@/components/common/WaitingBlock.vue'
    import ItemMenuList from '@/components/common/ItemMenuList.vue'
    import MenuCard from'@/components/common/MenuCard'
    import Constants from "@/store/constants";
    import { mapState } from 'vuex';
    import VueCookie from 'vue-cookie';
    // Tell Vue to use the plugin
    //Vue.use(VueCookie);
    export default {
        name: "DayTemplateSourcePanel",
        components: { Portlet, WaitingBlock, ItemMenuList, MenuCard },
        computed: {
            Constants: () => Constants.boxTypes,
            ...mapState({
                isLoadingStationClocks: state => state.loadingStates.isLoadingStationClocks,
                isLoadingStationBoxess: state => state.loadingStates.isLoadingStationBoxes,
                boxListGrouped: state => state.stationBoxesGrouped,
                stationClocks: state => {
                    if (state.stationClocks == null) return [];
                    return state.stationClocks.items;
                },
            }),
            sections() {
                var sections = [{ key: "CLOCKS", type: 'clock', event: "addClockToDayTemplate", name: "Clocks", items: this.stationClocks.sort(itm => itm.name) }];
                if (this.boxListGrouped) {
                    sections.push(Object.assign({ key: "UNDEFINED", type: 'playlist', event: "addPlaylistToDayTemplate" }, this.boxListGrouped.UNDEFINED || []));
                    sections.push(Object.assign({ key: "PODCAST", type: 'podcast', event: "addPodcastToDayTemplate" }, this.boxListGrouped.PODCAST || []));
                    //sections.push(Object.assign({ key: "PROMO", type: 'promo', event: "addPromoToDayTemplate" }, this.boxListGrouped.PROMO || []));
                }

                return sections;
            }
        },
        data() {
            var allowedBoxTypes = [Constants.boxTypes.BOX, Constants.boxTypes.PODCAST];
            var allowedTrackTypes = [Constants.trackTypes.MUSIC, Constants.trackTypes.JINGLE, Constants.trackTypes.VOICE_TRACK];
            return {
                expandedSections: [],
                allowedBoxTypes,
                allowedTrackTypes
            }
        },
        methods: {
            emitEvent: function (eventName, clock) {
                console.log(eventName);
                EventBus.$emit(eventName, clock);
            },
            toggleSection(sectionKey) {
                let expandedSectionsCopy = [...this.expandedSections];
                if(expandedSectionsCopy.includes(sectionKey)) {
                    expandedSectionsCopy = expandedSectionsCopy.filter(key => key !== sectionKey);
                } else {
                    expandedSectionsCopy = [...expandedSectionsCopy, sectionKey]
                }
                this.expandedSections = expandedSectionsCopy;
            }
        }
    }
</script>
<style lang="scss">
    @import "global_var";
    .accordion {
        display: flex;
        flex-direction: column;
        height: 100%;
        overflow: auto;
    }

        .day-template__source-panel--list-group {
            overflow: auto
        }

        .accordion div.items-menu-container {
            // flex-grow: 0;
            // height: 45px; /* Default header size */
        }

            .accordion div.items-menu-container.expanded {
                // flex-grow: 1;
                position: relative;
            }

                .accordion div.items-menu-container.expanded .items-menu-list {
                    overflow: hidden;
                    height: 100%;
                }

                .accordion div.items-menu-container.expanded .list-group {
                    overflow: auto;
                }

                    /* .accordion div.items-menu-container.expanded .list-group .list-group-item {} */

    .menu-label {
        display: flex;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    div.category i {
        width: 18px;
    }

    span.decorator a {
        text-decoration: none;
    }

    span.decorator a {
        display: inline-block;
        width: 18px;
    }


    .list-group-item:hover span.decorator a i.fa-plus {
        display: inline;
    }

    span.decorator a i.fa-circle {
        display: inline;
    }

    .m-content .right-panel {
        width: 250px;
        margin-left: 10px;
    }
</style>
